import { useMemo } from 'react';
import { TField, TInputField } from '../types/types.ts';

const useGroupedFields = (fields: TField[]): (TField | TField[])[] => useMemo(() => {
  if (!fields) {
    return [];
  }

  const grouped: (TField | TField[])[] = [];
  let currentGroup: TField[] = [];

  for (const field of fields) {
    if ((field as TInputField).flex) {
      currentGroup.push(field);
    } else {
      if (currentGroup.length > 0) {
        grouped.push([...currentGroup]);
        currentGroup = [];
      }
      grouped.push(field);
    }
  }

  if (currentGroup.length > 0) {
    grouped.push([...currentGroup]);
  }

  return grouped;
}, [fields]);

export default useGroupedFields;
